import React from "react"
import Index from "../Index"
import { contentLayout, modules } from "../../config/pages"
import { useUser } from "../../contexts/UserContext"
import Forbidden from "../Forbidden"

function EditTemplate (){
  const {user} = useUser()
  let view = contentLayout[modules.EditTemplate]
  if(user.permissions.views.length && !user.permissions.views.join().includes(modules.EditTemplate.toLowerCase())){
    view = Forbidden
  }
  return(
  <Index content={view} module={modules.EditTemplate}></Index>
 )
}

export default EditTemplate
